import React from 'react'

import CheckBox from '../common/CheckBox'
import SearchInput from '../common/SearchInput'
import Select from '../common/inputs/Select'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'

import { ShoppersStore, SelectionStore } from '../../store'
import { observer } from 'mobx-react-lite'
import { useText } from '../../texts'

const VisitFilterTab = observer(() => {
  const t = useText()
  const filter = ShoppersStore.filter
  const filterOptions = ShoppersStore.filterOptions

  const changeFilter = (key, value) => {
    ShoppersStore.changeFilter(key, value)
  }
  const submitFilter = () => SelectionStore.recommendShoppers()

  const showFilterStyles = {
    opacity: 1,
    transition: 'all .3s ease-in',
    height: 'auto',
  }
  const hideFilterStyles = {
    opacity: 0,
    height: 0,
  }
  return (
    <div>
      <div className="filter-menu__title">{t('select-shoppers')}</div>

      <div className="range-label">
        <div>{t('age')}</div>
        <div className="range-label__value">
          {filter.ageRange[0]}-{filter.ageRange[1]}
        </div>
      </div>
      <Slider.Range
        min={0}
        max={100}
        defaultValue={filter.ageRange}
        onChange={(v) => changeFilter('ageRange', v)}
      ></Slider.Range>

      <Select
        placeholder={t('sex')}
        options={filterOptions.gender}
        getOptionLabel={(option) => t(option.label)}
        onChange={(v) => changeFilter('gender', v)}
        value={filter.gender?.label && t(filter.gender?.label)}
      ></Select>

      <div className="filter-checkbox-row" style={{ marginTop: '3rem' }}>
        <CheckBox
          value={filter.isLimit}
          handle={(v) => changeFilter('isLimit', v)}
          placeholder={t('visits-limit')}
        ></CheckBox>
      </div>
      <div className="filter-checkbox-row">
        <CheckBox
          value={filter.isRotation}
          handle={(v) => changeFilter('isRotation', v)}
          placeholder={t('with-rotation')}
        ></CheckBox>
      </div>
      <div className="filter-checkbox-row">
        <CheckBox
          value={filter.isStep}
          handle={(v) => changeFilter('isStep', v)}
          placeholder={t('with-step')}
        ></CheckBox>
      </div>

      <div className="range-label" style={{ marginTop: '3rem' }}>
        {t('search-radius')}
      </div>
      <Select
        placeholder={t('search-radius')}
        options={filterOptions.radius}
        getOptionLabel={(option) => option.value + t('km')}
        onChange={(v) => changeFilter('radius', v)}
        value={filter.radius?.value && filter.radius?.value + t('km')}
      ></Select>

      <div className="filter-checkbox-row">
        <CheckBox
          placeholder={t('car-available')}
          value={filter.isAuto}
          handle={(v) => changeFilter('isAuto', v)}
        />
      </div>
      <div className="filter-checkbox-row">
        <CheckBox
          value={filter.isAutoOut}
          handle={(v) => changeFilter('isAutoOut', v)}
          placeholder={t('shopper-out')}
        />
      </div>
      <div style={filter.isAuto ? showFilterStyles : hideFilterStyles}>
        <SearchInput
          id="car"
          placeholder={t('auto-model')}
          value={filter.auto}
          handle={(v) => changeFilter('auto', v)}
        />
      </div>

      <div className="block-custom-scroll"></div>

      <div className="filter-list__bottom">
        <button className="btn btn-primary" onClick={submitFilter}>
          {t('search')}
        </button>
      </div>
    </div>
  )
})
export default VisitFilterTab
